import stopExpertise from './stopExpertise.vue'
export default stopExpertise